import { useNavState } from '@/hooks/use-nav-state';
import { cn } from '@/lib/cn';
import { BookOpen, MessageSquare, Sparkles, Sun } from 'lucide-react';
import { Link, useLocation } from 'react-router';

const TABS = [
  { href: '/spark', label: 'Spark', Icon: Sparkles, key: 'spark' },
  { href: '/today', label: 'Today', Icon: Sun, key: 'today' },
  { href: '/notes', label: 'Study', Icon: BookOpen, key: 'notes' },
  { href: '/tutor', label: 'Tutor', Icon: MessageSquare, key: 'tutor' },
] as const;

export function MobileNav() {
  const { pathname } = useLocation();
  const navState = useNavState();
  if (pathname === '/tutor' || pathname.startsWith('/tutor/')) return null;
  return (
    <nav
      aria-label="Primary"
      className="pb-safe fixed bottom-0 left-0 right-0 z-40 border-t border-[var(--color-border)] bg-[var(--color-surface)]/92 backdrop-blur-md md:hidden"
    >
      <ul className="mx-auto grid max-w-xl grid-cols-4">
        {TABS.map((t) => {
          const active = pathname === t.href || pathname.startsWith(`${t.href}/`);
          const state = navState[t.key];
          return (
            <li key={t.href}>
              <Link
                to={t.href}
                className={cn(
                  'flex flex-col items-center gap-0.5 py-2 text-[10px] font-medium transition-colors',
                  active ? 'text-[var(--color-primary)]' : 'text-[var(--color-muted-foreground)]',
                )}
              >
                <span
                  className={cn(
                    'grid size-7 place-items-center rounded-full transition-all duration-[var(--duration-fast)] ease-[var(--ease-out)]',
                    active ? 'bg-[var(--color-primary-soft)] scale-105' : 'scale-100',
                  )}
                >
                  <t.Icon className="size-[17px]" strokeWidth={active ? 2 : 1.75} />
                </span>
                <span className="leading-none">{t.label}</span>
                <span
                  className={cn(
                    'mt-px text-[9px] font-medium leading-none tracking-tight truncate max-w-[72px]',
                    state.emphasized && !active
                      ? 'text-[var(--color-primary)]'
                      : active
                        ? 'text-[var(--color-primary)]/80'
                        : 'text-[var(--color-subtle-foreground)]',
                  )}
                >
                  {state.subtitle}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
